import { useState, useEffect, useCallback } from 'react';
import { message, Modal } from 'antd';
import { shippingAPI, type GetChannelsParams } from '../../../services/shippingService';
import type { ShippingChannel } from '../../../types/shipping-types';

interface ChannelFilters {
    destination: string;
    shipping_method: string;
    is_active: string;
}

export const useChannels = () => {
    const [channels, setChannels] = useState<ShippingChannel[]>([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState<ChannelFilters>({
        destination: '',
        shipping_method: '',
        is_active: '',
    });

    const loadChannels = useCallback(async () => {
        setLoading(true);
        try {
            const params: GetChannelsParams = {};
            if (filters.destination) params.destination = filters.destination;
            if (filters.shipping_method) params.shipping_method = filters.shipping_method;
            if (filters.is_active) params.is_active = filters.is_active;

            const response = await shippingAPI.getChannels(params);
            const data = response.data as any;
            const channelsData = data.results || data;

            setChannels(Array.isArray(channelsData) ? channelsData : []);
        } catch (error) {
            console.error('Load error:', error);
            message.error('加载物流渠道失败');
            setChannels([]);
        } finally {
            setLoading(false);
        }
    }, [filters]);

    useEffect(() => {
        loadChannels();
    }, [loadChannels]);

    const handleDelete = (id: number) => {
        Modal.confirm({
            title: '确认删除',
            content: '确定要删除这个物流渠道吗？运费阶梯也将一并删除。',
            onOk: async () => {
                try {
                    await shippingAPI.deleteChannel(id);
                    message.success('删除成功');
                    loadChannels();
                } catch (error) {
                    message.error('删除失败');
                }
            },
        });
    };

    const updateFilters = (newFilters: Partial<ChannelFilters>) => {
        setFilters((prev) => ({ ...prev, ...newFilters }));
    };

    return {
        channels,
        loading,
        filters,
        updateFilters,
        handleDelete,
        reload: loadChannels,
    };
};
